import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * TreatmentCard component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    treatmentCard: {
      display: 'flex',
      border: `${variables.borderWidth.md} solid ${variables.color.primary.lightGrayDarker}`,
      paddingRight: theme.spacing(2.5),
      borderRadius: variables.borderRadius.sm,
      height: '7.4rem',
      transition: 'all 0.15s',

      '&[data-grouped=false]': {
        // marginBottom: theme.spacing(2),
        cursor: 'pointer',
      },

      '&[data-grouped=true]': {
        border: 'none',
        borderRadius: 'unset',
      },

      '&.dragging-over': {
        opacity: variables.opacity.half,
      },

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        height: 'auto',
        paddingRight: 0,
      },
    },

    indicatorWrapper: {
      width: '0.4rem',
      marginRight: theme.spacing(2),

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        marginRight: '9px',
      },
    },

    indicator: {
      background: variables.colorV2.userStory.indicator,
      borderRadius: `${variables.borderRadius.sm} 0 0 ${variables.borderRadius.sm}`,
      height: '100%',
      position: 'relative',
      width: '100%',

      '&[data-grouped=true]': {
        borderRadius: 'unset',
      },

      '&::after': {
        borderColor: `transparent transparent transparent ${variables.colorV2.userStory.indicator}`,
        borderStyle: 'solid',
        borderWidth: '10px',
        content: '""',
        position: 'absolute',
        right: '-1.6rem',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },

    cardContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },

    labelWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.75),
      minWidth: '190px',

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        minWidth: 'unset',
      },

      ['& svg']: {
        ['@media (min-width: 1024px) and (max-width: 1580px)']: {
          marginTop: '6px',
        },
      },
    },

    treatmentLeft: {
      display: 'flex',
      flexDirection: 'column',
      gap: '3px',

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        // flexDirection: 'row',
        gap: '2px', //'11px',
        paddingBottom: '4px',
        paddingTop: '7px',
        // alignItems: 'center',
      },
    },

    treatmentName: {
      fontSize: `${variables.font.size.lg}!important`,
      fontWeight: `700!important` as any,
    },

    treatmentTag: {
      fontSize: `${variables.font.size.sm}!important`,
      color: variables.color.primary.gray,
    },

    treatmentInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '5px',

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        justifyContent: 'space-between',
        width: '100%',
      },
    },

    treatmentRight: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      alignItems: 'flex-end',

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        flexDirection: 'row', // 'column',
        alignItems: 'flex-start',
      },
    },

    treatmentRightGroupedTreatment: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      alignItems: 'flex-end',

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        flexDirection: 'row', // 'column',
        alignItems: 'flex-start',
        paddingLeft: '2.2em',
      },
    },

    treatmentBtnSave: {
      minWidth: 'auto',
      cursor: 'pointer',
      width: '34px',
      padding: '6px',
    },

    contentName: {
      display: 'flex',
      gap: theme.spacing(0.5),
      marginRight: theme.spacing(1),
      textAlign: 'right',

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        textAlign: 'left',
      },
    },

    treatmentValues: {
      background: variables.colorV2.personalizationToken.background,
      borderRadius: '1.6rem',
      padding: theme.spacing(0.25, 1),
      color: variables.colorV2.personalizationToken.text,
      display: 'flex',
      gap: theme.spacing(0.5),
      border: `${variables.borderWidth.md} solid transparent`,
      width: 'fit-content',

      '&[data-indicated=false]': {
        background: variables.color.primary.white,
        border: `${variables.borderWidth.md} solid ${variables.colorV2.personalizationToken.border}`,

        '& $value': {
          // color: `${variables.color.primary.darkestGray}!important`,
        },

        '& $percent': {
          // color: `${variables.color.primary.darkestGray}!important`,
        },
      },

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        marginBottom: '8px',
      },
    },

    value: {
      color: variables.colorV2.personalizationToken.text,
      fontWeight: 500,
    },

    percent: {
      color: variables.colorV2.personalizationToken.text,
      fontWeight: 400,
      lineHeight: variables.lineHeight.sm,
    },

    menu: {
      marginLeft: theme.spacing(0.5),
      padding: theme.spacing(1),
      border: 'none',

      '&:hover, &[data-opened="true"]': {
        border: 'none',
      },
    },
  }),
);
